import styled from 'styled-components';
import { Colors } from '../patterns/Colors';

const gridBg = '#F6FAFD';
const dotColor = Colors.textLightest;

// 10px tiling dot pattern, mirroring RenderGrid's small dot grid.
const dotGrid = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
        <circle cx="5" cy="5" r="1" fill="${dotColor}"/>
    </svg>`,
);

export const Page = styled.div<{ variant?: 'default' | 'board' }>`
    background: white;
    min-height: 100vh;

    @media (min-width: 640px) {
        background: ${Colors.hover};
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${({ variant }) => variant === 'board' && `
        background: ${gridBg};
        background-image: url("data:image/svg+xml,${dotGrid}");
        background-repeat: repeat;

        @media (min-width: 640px) {
            background: ${gridBg};
            background-image: url("data:image/svg+xml,${dotGrid}");
            background-repeat: repeat;
        }
    `}
`;
